<template>
  <div class="page">
    <main>
      <el-table
        :data="listData"
        height="calc(100vh - 100px)"
        style="width: 100%"
      >
        <template slot="empty">
          <img
            src="../../assets/list-none.png"
            alt=""
            width="400"
            class="table-empty"
          />
          <div>空荡荡的～暂无数据！</div>
        </template>
        <el-table-column prop="houseName" label="房源名称" align="center">
        </el-table-column>
        <el-table-column label="承租人" align="center" width="200px">
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              content="test"
              width="400px"
              trigger="click"
            >
              <el-table :data="scope.row.renters">
                <el-table-column
                  width="150"
                  property="renterName"
                  label="姓名"
                ></el-table-column>
                <el-table-column
                  width="150"
                  property="renterPhone"
                  label="手机号"
                ></el-table-column>
                <el-table-column
                  width="150"
                  property="cardType"
                  label="证件类型"
                ></el-table-column>
                <el-table-column
                  width="150"
                  property="cardNum"
                  label="证件号码"
                ></el-table-column>
              </el-table>
              <div slot="reference" class="name-wrapper">
                <el-tag style="cursor: pointer" size="medium">{{
                  scope.row.renters ? scope.row.renters[0].renterName : ""
                }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="areaName" label="所属区域" align="center">
        </el-table-column>
        <el-table-column prop="leaseStartStr" label="开始时间" align="center">
        </el-table-column>
        <el-table-column prop="leaseEndStr" label="结束时间" align="center">
        </el-table-column>
        <el-table-column prop="leaseCreatedTime" label="办理时间" align="center">
        </el-table-column>
        <el-table-column prop="state" label="合同状态" align="center">
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-button
                size="mini"
                style="padding: 5px 5px; width: 80px"
                type="success"
                round
                v-if="scope.row.state == '生效中'"
                >{{ scope.row.state }}</el-button
              >
              <el-button
                size="mini"
                style="padding: 5px 5px; width: 80px"
                type=""
                round
                v-else-if="scope.row.state == '未生效'"
                >{{ scope.row.state }}</el-button
              >
              <el-button
                size="mini"
                style="padding: 5px 5px; width: 80px"
                type="info"
                round
                v-else-if="scope.row.state == '已过期'"
                >{{ scope.row.state }}</el-button
              >
              <el-button
                size="mini"
                style="padding: 5px 5px; width: 80px"
                type="danger"
                round
                v-else-if="scope.row.state == '已作废'"
                >{{ scope.row.state }}</el-button
              >
              <el-button
                size="mini"
                style="padding: 5px 5px; width: 80px"
                type="warning"
                round
                v-else-if="scope.row.state == '已退房'"
                >{{ scope.row.state }}</el-button
              >
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="left" width="300">
          <template slot-scope="scope">
            <!-- <el-button
              @click.native.prevent="gotoEdit('renters', scope.row.renters)"
              type="text"
            >
              租客
            </el-button> -->

            <el-button
              @click.native.prevent="gotoEdit('pricings', scope.row.pricings)"
              type="text"
            >
              收费项目
            </el-button>

            <el-button
              @click.native.prevent="gotoEdit('bills', scope.row.bills)"
              type="text"
            >
              账单
            </el-button>
            <el-button
              type="warning"
              size="mini"
              @click="checkOut(scope.row.id)"
              >退房</el-button
            >
            <el-button
              size="mini"
              @click.native.prevent="handleDelete(scope.row)"
              type="danger"
            >
              {{scope.row.state=="已作废"?"取消作废":"作废"}}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </main>

       <footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIdx"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="itemTotal"
          :page-sizes="[10, 20, 30, 40, 50]"
        >
        </el-pagination>
      </footer>
      

    <el-dialog
      :visible.sync="renters"
      width="80%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="div-center">
        <el-table :data="listItemData" style="width: 100%" border>
          <el-table-column prop="renterName" label="姓名" align="center">
          </el-table-column>
          <el-table-column prop="renterPhone" label="手机号" align="center">
          </el-table-column>
          <el-table-column prop="cardType" label="证件类型" align="center">
          </el-table-column>
          <el-table-column prop="cardNum" label="证件号码" align="center">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="pricings"
      width="80%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="div-center">
        <el-table :data="listItemData" style="width: 100%" border>
          <el-table-column prop="name" label="项目名称" align="center">
          </el-table-column>
          <el-table-column prop="type" label="项目类型" align="center">
          </el-table-column>
          <el-table-column prop="unit" label="计价单位" align="center">
          </el-table-column>
          <el-table-column label="价格(元)" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.amountStr }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="isPostPayStr" label="付费规则" align="center">
          </el-table-column>
          <el-table-column prop="comment" label="备注" align="center">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="bills"
      width="80%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="div-center">
        <el-table :data="listItemData" max-height="500px" style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="付款人姓名">
                  <span>{{ props.row.payer.renterName }}</span>
                </el-form-item>
                <el-form-item label="电话号码">
                  <span>{{ props.row.payer.renterPhone }}</span>
                </el-form-item>
                <el-form-item label="证件类型">
                  <span>{{ props.row.payer.cardType }}</span>
                </el-form-item>
                <el-form-item label="证件号码">
                  <span>{{ props.row.payer.cardNum }}</span>
                </el-form-item>
                <el-form-item label="支付方式">
                  <span>{{ props.row.payType }}</span>
                </el-form-item>
                <el-form-item label="支付时间">
                  <span>{{ props.row.paidTimeStr }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column prop="pricingName" label="收费项目" align="center">
          </el-table-column>
          <el-table-column prop="billStartStr" label="开始时间" align="center">
          </el-table-column>
          <el-table-column prop="billEndStr" label="结束时间" align="center">
          </el-table-column>
          <el-table-column label="应收金额(元)" align="center">
            <template slot-scope="scope">
              <span>{{ numFormat(scope.row.totalAmountStr) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实收金额(元)" align="center">
            <template slot-scope="scope">
              <span>{{ numFormat(scope.row.paidAmountStr) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="payState" label="支付状态" align="center">
          </el-table-column>
          <el-table-column
            prop="invoiceFlagStr"
            label="是否开票"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="comment" label="备注" align="center">
          </el-table-column>
        </el-table>
      </div>
      <div style="text-align: center;">
        <footer>
          <el-pagination
            @size-change="handleSizeChangeBills"
            @current-change="handleCurrentChangeBills"
            :current-page="pageIdxBills"
            :page-size="pageSizeBills"
            layout="total, sizes, prev, pager, next, jumper"
            :total="itemTotalBills"
            :page-sizes="[10, 20, 30, 40, 50]"
          >
          </el-pagination>
        </footer>
      </div>
    </el-dialog>
     <!-- <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogUploadVisible"
      title="退款"
      width="50%"
    >
      <refund ></refund>
    </el-dialog> -->
     <refund  ref="refund" @close="onRefundClose"></refund>
  </div>
</template>

<script>
import axios from "axios";
import Utils from "../../Utils";
import { Loading } from "element-ui";
import Refund from "./Refund";
import mixins from "../../minix";

export default {
  name: "home",
  components: { Refund },

  mixins: [mixins],

  data() {
    return {
      pageIdx: 0,
      pageSizeBills: 20,
      pageIdxBills: 0,
      dialogUploadVisible:false,
      itemTotal: 0,
      itemTotalBills: 20,
      renters: false,
      pricings: false,
      bills: false,
      cover: "",
      listData: [],
      listItemData: [],
      billsList:[],
    };
  },

  created() {
    Utils.userInfo.houseID = this.$route.query.houseID;

    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", "Web_Admin");

    this.query(0);
  },
  methods: {
    onRefundClose() { 
      this.query(this.pageIdx-1)
    },
    checkOut(id) {
      // 调用公共页面及其方法
      this.$refs.refund.checkOutLease(id, this.$route.query.orgID); 

    },

    // 进入编辑界面
    gotoEdit(item, list) {
      // eslint-disable-next-line no-console 
      // eslint-disable-next-line no-console 
      if (item === "renters") {
        this.listItemData = list;
        this.renters = true;
      }
      if (item === "pricings") {
        this.pricings = true;
        this.listItemData = [];
        list.forEach((listItem) => {
          if (listItem.name == "水费" || listItem.name == "电费") {
            // 处理水电费保留4位小数的问题
            listItem.amountStr = this.meterPricing(listItem.amount / 10000);
          } else {
            listItem.amountStr = this.numFormat(listItem.amount / 100);
          }
          listItem.isPostPayStr = listItem.isPostPay ? "后付费" : "预付费";
          this.listItemData.push(listItem);
        });
      }
      if (item === "bills") {
        this.bills = true;
        this.listItemData = [];
        list.forEach((listItem) => {
          listItem.billStartStr = Utils.long2day(listItem.billStart * 1000);
          listItem.billEndStr = Utils.long2day(listItem.billEnd * 1000);
          listItem.paidTimeStr = Utils.long2second(listItem.paidTime * 1000);
          listItem.totalAmountStr = listItem.totalAmount / 100;
          listItem.paidAmountStr = listItem.paidAmount / 100;
          listItem.invoiceFlagStr = listItem.invoiceFlag ? "已开票" : "未开票";
          this.listItemData.push(listItem);
        });
      }
      this.itemTotalBills = this.listItemData.length
      this.billsList = this.listItemData
      this.handleCurrentChangeBills(1);
    },

    handleDelete(item) {

      var hintMsg =""
      var data={}
      if (item.state =="已作废"){
        hintMsg="此操作将恢复当前合同，但是已作废的续约租约不会恢复，如需续约，请重新执行续约操作，"
        data={
              leaseID: item.id,
              undoDel:true,
            }
      }else{
        hintMsg="此操作将解除当前合同，并作废所有关联的账单以及续约租约，"
        data={
              leaseID: item.id,
            }
      }
      this.$confirm(hintMsg+"是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axios({
            method: "post",
            url: "leases/delete",
            data: data,
          })
            .then((value) => {
              if (value.data.code === 0) {
                this.$message.success(value.data.message);
              } else {
                this.$message.error(value.data.message);
              }
              this.pageIdx = 0;
              this.query(0);
            })
            .catch(() => {});
        })
        .catch(() => {});
    },

    handleCurrentChange(val) {

      // eslint-disable-next-line no-console 
      this.pageIdx = val;
      this.query(val - 1);
    },

    handleSizeChange(val) {

      // eslint-disable-next-line no-console 
      this.pageIdx = 0;
      this.pageSize = val;
      this.query(0);
    },

    handleCurrentChangeBills(val) {
      this.listItemData=[]
      var num= val*this.pageSizeBills -this.pageSizeBills
      for (var i=num; i<this.billsList.length; i++)
      {
        if  (i<val*this.pageSizeBills){
          this.listItemData.push(this.billsList[i])
        }else{
          break
        }
      } 
    },

    handleSizeChangeBills(val) {
      this.pageSizeBills = val;
      this.handleCurrentChangeBills(1) 
    },

    //列表查询
    query(pageIdx) {
      if(pageIdx<=0){
        pageIdx=0
      }
      let data = {
        pageSize: this.pageSize,
        houseID: Utils.userInfo.houseID,
        pageIdx: pageIdx,
      };

      const loading = Loading.service({
        lock: true,
        text: "加载列表中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
      });

      axios({
        method: "post",
        url: "leases/query",
        data: data,
      })
        .then((value) => {
          this.listData = [];
          this.itemTotal = value.data.total;
          if (value && value.data && value.data.data) {
            value.data.data.forEach((item) => {
              item.leaseStartStr = Utils.long2day(item.leaseStart * 1000);
              if( item.leaseEnd ==0xFFFFFFFFF-36001){
                item.leaseEndStr="无限期"
              }else{
                item.leaseEndStr = Utils.long2day(item.leaseEnd * 1000);
              }
              item.leaseCreatedTime = Utils.long2second(item.createdTime * 1000)
              this.listData.push(item);
            });
          }
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
          // this.listData.push({
          //   bills: []
          // });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../style.css";

.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
